import React from 'react';

// Stats Summary Component
const StatsSummary = React.memo(({ isLoading, totalEarnings, averageBookingPrice, conversionRate, bookings, formatPrice }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
    <div className="bg-[#121212] rounded-xl shadow-lg p-4 border border-white/20">
      <h3 className="text-sm font-medium text-white mb-2">Total Earnings</h3>
      {isLoading ? (
        <div className="h-8 w-32 bg-gray-800 animate-pulse rounded-md"></div>
      ) : (
        <p className="text-2xl font-bold text-white">{formatPrice(totalEarnings)}</p>
      )}
    </div>
    
    <div className="bg-[#121212] rounded-xl shadow-lg p-4 border border-white/20">
      <h3 className="text-sm font-medium text-white mb-2">Avg. Booking Price</h3>
      {isLoading ? (
        <div className="h-8 w-32 bg-gray-800 animate-pulse rounded-md"></div>
      ) : (
        <p className="text-2xl font-bold text-white">{formatPrice(averageBookingPrice)}</p>
      )}
    </div>
    
    <div className="bg-[#121212] rounded-xl shadow-lg p-4 border border-white/20">
      <h3 className="text-sm font-medium text-white mb-2">Conversion Rate</h3>
      {isLoading ? (
        <div className="h-8 w-32 bg-gray-800 animate-pulse rounded-md"></div>
      ) : (
        <p className="text-2xl font-bold text-white">{conversionRate.toFixed(1)}%</p>
      )}
    </div>
    
    <div className="bg-[#121212] rounded-xl shadow-lg p-4 border border-white/20">
      <h3 className="text-sm font-medium text-white mb-2">Total Bookings</h3>
      {isLoading ? (
        <div className="h-8 w-32 bg-gray-800 animate-pulse rounded-md"></div>
      ) : (
        <p className="text-2xl font-bold text-white">{bookings.length}</p>
      )}
    </div>
  </div>
));

export default StatsSummary; 